import React from "react";
//#region types
import { StyledButtonProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Button, CircularProgress } from "@mui/material";
//#endregion
import { CSSHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const StyledButton: React.FC<StyledButtonProps> = (props) => {
  const {
    size,
    displayType,
    onClick,
    disabled,
    endIcon,
    startIcon,
    type,
    secondary,
    autoFocus,
    isSubmitting,
    href,
    testId,
  } = props;

  return (
    <Button
      className={clsx(
        cssExports.button,
        size === "xs" ? cssExports.btnXSmall : size === "sm" ? cssExports.btnSmall : "",
        CSSHelper.getClassByDisplayType(displayType),
        secondary ? cssExports.btnSecondary : "",
        props.className
      )}
      onClick={onClick}
      disabled={disabled || isSubmitting}
      startIcon={startIcon}
      endIcon={
        isSubmitting ? (
          <CircularProgress size={25} className={cssExports.buttonProgress} data-testid={`${testId}Progress`} />
        ) : (
          endIcon
        )
      }
      type={type}
      autoFocus={autoFocus}
      href={href}
      data-testid={testId}
    >
      {props.children}
    </Button>
  );
};

export default StyledButton;
